import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}

/**
 * Convert typography variants from GraphQL array format to Record format
 * GraphQL returns: [{ name: 'body', fontSize: 'base', ... }]
 * We need: { body: { fontSize: 'base', ... } }
 */
export function convertVariantsToRecord(
  variants:
    | Array<{ name: string; [key: string]: any }>
    | Record<string, any>
    | null
    | undefined,
): Record<string, any> {
  // Handle null/undefined
  if (!variants) return {};

  // If already a Record (not an array), return as-is
  if (!Array.isArray(variants)) return variants;

  // Convert array to Record keyed by name
  return variants.reduce(
    (acc, variant) => {
      const { name, ...rest } = variant;
      acc[name] = rest;
      return acc;
    },
    {} as Record<string, any>,
  );
}
